import { createConfig, lazyRoute, type Route } from "../config/config-utils"
import { WHEN } from "../config/constants"

const TranslateApp = lazyRoute(()=> import("./TranslateApp"), "TranslateApp")
const TranslateAppA = lazyRoute(()=> import("./TranslateApp"), "TranslateAppA")
const TranslateAppB = lazyRoute(()=> import("./TranslateApp"), "TranslateAppB")
const TranslateAppC = lazyRoute(()=> import("./TranslateApp"), "TranslateAppC")

export const TRANSLATE_CONFIG = createConfig({
  component: TranslateApp,
  key: "translate-it",
  label: "TranslateIt",
  mobile: false,
  when: WHEN,
})

export const TRANSLATE_A_CONFIG: Route | null = WHEN
  ? {
      browserTitle: "TranslateIt A",
      component: TranslateAppA,
      key: "translate-it-a",
      label: "TranslateItA",
      route: "/translate-it-a",
    }
  : null

export const TRANSLATE_B_CONFIG: Route | null = WHEN
  ? {
      browserTitle: "TranslateIt B",
      component: TranslateAppB,
      key: "translate-it-b",
      label: "TranslateItB",
      route: "/translate-it-b",
    }
  : null

export const TRANSLATE_C_CONFIG: Route | null = WHEN
  ? {
      browserTitle: "TranslateIt C",
      component: TranslateAppC,
      key: "translate-it-c",
      label: "TranslateItC",
      route: "/translate-it-c",
    }
  : null
